var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "relative ",
      class: { "w-full": _vm.isMobile() && _vm.showSidebarOnMobile }
    },
    [
      _vm.isMobile() && !_vm.showSidebarOnMobile
        ? _c(
            "button",
            {
              staticClass:
                "absolute z-50 top-15 bg-indigo-500 rounded-r-md  text-white p-2",
              on: { click: _vm.toggleSidebar }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "h-6 w-6",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M13 5l7 7-7 7M5 5l7 7-7 7"
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass:
            " lg:flex flex-col  w-full max-w-xs flex-grow flex-shrink-0 border-r bg-gray-300 h-full",
          class: {
            "absolute z-50": _vm.isMobile() && _vm.showSidebarOnMobile,
            "relative z-10": !_vm.isMobile(),
            hidden: _vm.isMobile() && !_vm.showSidebarOnMobile
          },
          staticStyle: { "min-width": "350px" }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex-shrink-0 px-4 py-2 flex items-center justify-between border-b bg-gray-200"
            },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.status,
                      expression: "status"
                    }
                  ],
                  staticClass:
                    " block w-full py-1 text-xs font-semibold text-gray-600 bg-transparent cursor-pointer",
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.status = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.statusChanged
                    ]
                  }
                },
                [
                  _c("option", { attrs: { selected: "", value: "open" } }, [
                    _vm._v("Mine & Open")
                  ]),
                  _c("option", { attrs: { value: "assigned" } }, [
                    _vm._v("Assigned")
                  ]),
                  _c("option", { attrs: { value: "closed" } }, [
                    _vm._v("Closed")
                  ])
                ]
              ),
              _vm.isMobile() && _vm.showSidebarOnMobile
                ? _c("div", { on: { click: _vm.toggleSidebar } }, [
                    _c(
                      "svg",
                      {
                        staticClass: "h-6 w-6",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M6 18L18 6M6 6l12 12"
                          }
                        })
                      ]
                    )
                  ])
                : _vm._e()
            ]
          ),
          _c(
            "div",
            {
              staticClass: "flex-1 overflow-y-auto h-full bg-white",
              on: { scroll: _vm.onScroll }
            },
            [
              _c(
                "div",
                { staticClass: "shadow" },
                _vm._l(_vm.chats, function(chat) {
                  return _c(
                    "div",
                    { key: chat.id, staticClass: "max-h-32 border-t relative" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass:
                            "block px-6 pt-3 pb-4 bg-white border-l-4 border-transparent hover:bg-gray-100",
                          attrs: {
                            to: {
                              name: "TeamInboxChat",
                              params: { conversationId: chat.id }
                            },
                            "active-class": "active"
                          }
                        },
                        [
                          _c("div", { staticClass: "flex justify-between" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "text-xs font-semibold text-gray-900"
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(chat.customer.firstName) + " "
                                )
                              ]
                            ),
                            _c(
                              "span",
                              { staticClass: "text-xs text-gray-600" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("relativetime")(chat.lastReplyTime)
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]),
                          _c(
                            "p",
                            {
                              staticClass:
                                "mt-1 text-xs text-gray-600 truncate pr-12"
                            },
                            [
                              _vm._v(" " + _vm._s(chat.preview) + " "),
                              _vm.getChatCount(chat.id) > 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "inline-block w-9 text-center py-1 leading-none text-xs font-semibold text-gray-700 bg-gray-300 rounded-full absolute right-6"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.getChatCount(chat.id)) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                }),
                0
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }